import React from "react";
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import * as echarts from "echarts";
import _ from 'lodash';


export const ChartRadar2 = (props) => {
    const { jsonData, chartName, chartHeight } = props;
    const { t } = useTranslation();
    const chartRef = React.useRef(null);
    const myChart = React.useRef(null);

    React.useEffect(() => {
        if (!myChart.current && chartRef.current) {
            myChart.current = echarts.init(chartRef.current);
        }

        const values = jsonData?.map(item => item.value);
        const maxValues = Math.max(...values);
        const affectiveData = jsonData?.map(item => ({
            id: item.name.toLowerCase().trim(),
            name: t(`assessment.${item.name.toLowerCase().trim().replace(/\s+/g, '')}`),
            itemStyle: { color: item.itemStyle.color, },
            max: maxValues,
            value: item.value,
        })) || [];

        const option = {
            title: {
                text: chartName,
                textStyle: {
                    fontSize: 30,
                    fontStyle: "normal",
                    color: "#131213",
                    fontWeight: "bold"
                },
                show: false,
            },
            tooltip: {
                show: true,
                trigger: 'axis',
                showDelay: 0,
                hideDelay: 100,
                transitionDuration: 0.4,
                enterable: false,
                backgroundColor: '#fff',
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, .2)",
            },
            legend: {
                left: 'center',
                data: [
                    chartName
                ],
                show: false,
            },
            textStyle: {
                fontSize: Math.round(myChart.current._dom.offsetWidth) < 500 ? 11 : 13,
                fontStyle: "normal",
                color: "#464646",
                fontWeight: "normal"
            },
            radar: [{
                indicator: affectiveData,
                center: ['50%', '50%'],
                radius: Math.round(myChart.current._dom.offsetWidth) < 400 ? 80 : Math.round(myChart.current._dom.offsetWidth) < 500 ? 100 : 140,
                axisName : { show: true},
            }],
            series: [{
                type: 'radar',
                tooltip: {
                    trigger: 'item'
                },
                areaStyle: {},
                data: [{
                    value: affectiveData?.map(obj => obj.value) || [],
                    name: chartName,
                }],
            }]
        };

        if (myChart.current) {
            myChart.current.showLoading();
            myChart.current.setOption(option);
            myChart.current.hideLoading();
        }
        
        
        // 창크기 변경할때 카트를 갱신한다.
        const handleResize = _.debounce(() => {
            if (myChart.current) {
                myChart.current.showLoading();
                myChart.current.setOption(option);
                myChart.current?.resize();
                myChart.current.hideLoading();
            }
        }, 50); // Debounce for 50ms

        window.addEventListener('resize', handleResize);

        return () => {
            try {
                window.removeEventListener('resize', handleResize);
            
                myChart.current && myChart.current.dispose();
                myChart.current && myChart.current.dispose();
                myChart.current = null;
            }
            catch (err) {
                console.log("Unload", new Date().toISOString(), JSON.stringify(err), err);
            }
        };
    }, [jsonData, chartName, chartHeight]);


    return <div ref={chartRef} style={{ width: "100%", height: chartHeight || "200px" }} />;
}

ChartRadar2.propTypes = {
    jsonData: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.func,
        PropTypes.object,
    ]).isRequired,
    chartName: PropTypes.string,
    chartHeight: PropTypes.string,
};
